export default "__VITE_PUBLIC_ASSET__5b3bdc80__"